module.exports = __webpack_public_path__ + "img/avatar5.dc1bd40f.jpg";